import Vue from 'vue';
import App from '@/pages/App.vue';
import Component from 'vue-class-component';
import QPhoneNumberInput from '@/components/QPhoneNumberInput.vue';
import QRoleSwitcher from '@/components/QRoleSwitcher.vue';
import QFileUpload from '@/components/QFileUpload.vue';
import QMediaLibrary from '@/components/QMediaLibrary.vue';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import VueTour from 'vue-tour';

// Vuex
import store from '@/store';

// Tab Events
import vueTabevents from 'vue-tabevents';
Vue.use(vueTabevents);

// i18n
import i18n from './i18n/i18n';

// ACL
import acl from './acl/acl';

// Router
import router from '@/router';

// Filters
import './filters';

// Directives
import './directives';

import './registerServiceWorker';

// VeeValidate
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  configure,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Custom Rules
import './validations';

// Apexcharts
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);

Vue.component('apexchart', VueApexCharts);

// Vue Tour
Vue.use(VueTour);
import 'vue-tour/dist/vue-tour.css';

localize('en', en);
configure({
  bails: false,
  mode: 'eager',
});

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

gsap.registerPlugin(ScrollToPlugin);

// Quescreen Component Lib
import { Quescreen, Vuetify, vuetifyOptions } from 'quescreen-component-lib';

import 'quescreen-component-lib/fonts/fonts.css';
import 'quescreen-component-lib/dist/lib.css';
import '@/assets/scss/style.scss';

Vue.use(Quescreen);

Vue.config.productionTip = false;

if (process.env.VUE_APP_STAGING === '1') {
  Vue.config.devtools = true;
}

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

Vue.component(QPhoneNumberInput.name, QPhoneNumberInput);
Vue.component('QRoleSwitcher', QRoleSwitcher);
Vue.component('QFileUpload', QFileUpload);
Vue.component('QMediaLibrary', QMediaLibrary);

new Vue({
  router,
  vuetify: new Vuetify(vuetifyOptions),
  i18n,
  store,
  acl,
  render: (h) => h(App),
}).$mount('#app');

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);
